import type { IconGlyph } from '@sunwebgroup/uds-ui/icon'
import type * as React from 'react'
import { Icon } from '@sunwebgroup/uds-ui/icon'
import { Typography } from '@sunwebgroup/uds-ui/typography'
import cn from 'classnames'
import styles from './IconRow.module.css'

interface IconRowProps {
  glyph: IconGlyph
  description: React.ReactNode
  className?: string
  size?: number
}

export function IconRow({ glyph, description, className, size = 16 }: IconRowProps) {
  return (
    <div className={cn(styles.row, className)}>
      <Icon glyph={glyph} size={size} className={styles.icon} />
      <Typography as="div" variant="body-s-regular-tight">{description}</Typography>
    </div>
  )
}
